exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_groupEditPanel_3SuRuoss9Z-vmsOFWP0_cN {\n  position: relative;\n  width: 100%;\n  float: left;\n}\n\n.IA_content_2MzGmPdE7rIdsgsxvohnjl {\n  position: relative;\n  float: left;\n  width: calc(100% - 40px);\n  height: 100%;\n  padding-left: 40px;\n  box-sizing: border-box;\n}", ""]);

// Exports
exports.locals = {
	"IA_groupEditPanel": "IA_groupEditPanel_3SuRuoss9Z-vmsOFWP0_cN",
	"IA_content": "IA_content_2MzGmPdE7rIdsgsxvohnjl"
};